import { HackleApp } from "../HackleWebAppClient"
import { HackleAppInvocationProcessor } from "./HackleAppInvocationProcessor"
import InvocatorFactory from "./InvocatorFactory"
import InvocationResponseResolver from "./InvocationResponseResolver"

export function createInvocationProcessor(hackleApp: HackleApp): HackleAppInvocationProcessor {
  const invocatorFactory = new InvocatorFactory()
  const invocator = invocatorFactory.getInvocator(hackleApp.getInvocationType(), new InvocationResponseResolver())
  if (invocator === null) {
    throw new Error(`Failed to get invocator with invocationType:${hackleApp.getInvocationType()}`)
  }

  return new HackleAppInvocationProcessor(invocator)
}
